import { Alert } from "@mui/material";
import { FallbackProps } from "react-error-boundary";

function ErrorFallback({ error }: FallbackProps) {
  return <Alert severity="error">{error.message}</Alert>;
}
export default ErrorFallback;
